import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router";
import { HeaderActionType } from "../../ManagePageComponents";
const TableHeaderContainer = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: "16px 16px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
}))

export default function TableHeader({
    title,
    subtitle,
    titleSize,
    newLabelName = "Add New",
    rerouteLabel,
    onBack,
    headerActions,
    disableDivider = false,
}: {
    title: string;
    titleSize?: string;
    onBack?: () => void;
    subtitle?: string | null | undefined;
    newLabelName?: string | null | undefined;
    rerouteLabel?: string | null | undefined;
    headerActions?: HeaderActionType[]
    disableDivider?: boolean;
}) {
    const navigate = useNavigate();

    const handleBack = () => (onBack ? onBack() : navigate("/dashboard"));
    return (
        <TableHeaderContainer
            sx={
                disableDivider
                    ? {}
                    : { border: "none", borderBottom: "2px solid rgb(209 213 219)" }
            }>
            <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
                {onBack && (
                    <IconButton onClick={handleBack} sx={{ marginRight: "8px" }}>
                        <ChevronLeftIcon />
                    </IconButton>
                )}
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography variant={titleSize as
                        "body1" | "body2" | "button" | "caption" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "subtitle1" | "subtitle2" | "overline" || "h4"} sx={{ textAlign: "left" }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Box>
                            <Typography
                                variant="body1"
                                sx={(t: any) => ({ color: t.palette.grey[500], textAlign: "left" })}
                            >
                                {subtitle}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
            <Box >
                {headerActions?.map((action) => {
                    return (
                        <Box component="div">
                            <Button
                                sx={{ visibility: action.isHidden ? "hidden" : "visible" }}
                                onClick={action.action} startIcon={action.icon} color="secondary">
                                {action.name}
                            </Button>
                        </Box>
                    )
                })}
            </Box>
        </TableHeaderContainer>
    );
}
